(ns teamoesterreich.user-mode.ui-helper.are-you-sure-modal
  (:require [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.done :refer [done]]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [reagent.core :as r]
            ))


(defn are-you-sure-modal [!show message ok-message on-ok-fn & [on-cancel-fn]]

  [mui/modal
   {
    :aria-labelledby  "simple-modal-title"
    :aria-describedby "simple-modal-description"
    :style            {:display        "flex"
                       :marginRight    "auto"
                       :marginLeft     "auto"
                       :alignItems     "center"
                       :justifyContent "center"}
    :open             (or @!show false)

    }
   [:div
    {
     :class "modal"
     :style {:width "90%" :maxWidth 800}
     }
    [:h4 message]

    [:br]
    [:br]
    [mui/grid
     {:container  true
      :direction  "row"
      :justify    "space-between"
      :alignItems "flex-start"
      :spacing    1
      }
     [mui/grid
      {:container false
       :item      true
       :md        6
       :xs        12
       }
      [mui/button
       {:color     "primary"
        :variant   "contained"
        :startIcon (r/as-element [keyboard-arrow-left])
        :style     {:marginRight 50}
        :onClick   (fn []
                     (if on-cancel-fn
                       (on-cancel-fn)
                       (reset! !show false)))
        }
       "Abbrechen"]]

     [mui/grid
      {:container false
       :item      true
       :md        6
       :xs        12
       }
      [mui/button
       {:style     {:float "right"}
        :variant   "contained"
        :startIcon (r/as-element [done])
        :onClick   (fn []
                     (on-ok-fn)
                     (reset! !show false))
        }
       ok-message]]
     ]]
   ]
  )


